import { Box, Grid, Button, TextField, Divider } from "@mui/material";
import React, { FC, useState, useEffect, useRef } from "react";
import { load, remove } from "constants/storage";
import { styled } from "@mui/material/styles";
import Slider from "@mui/material/Slider";
import { H3, H4, H5, H6, Small, Tiny } from "components/Typography";
import moment from "moment";
import GoalTopBanner from "components/GoalTopBanner";
import { useAppDispatch } from "../../store/hooks";
import ProgressBar from "react-customizable-progressbar";
import { useNavigate } from "react-router-dom";
import {
  DateList,
  GOAL_TYPES,
  GOLD_DISCLAIMER,
  INSTRUMENT_TYPES,
  MUTUAL_DISCLAIMER,
  SILVER_DISCLAIMER,
} from "constants/constant";
import { toast } from "react-hot-toast";
import { PAYMENT_URL_DEV, MERCHANTS_ID } from "common/common";
import CircularProgress from "@mui/material/CircularProgress";
import DashboardNavbar from "components/DashboardNavbar";
import GoalYearModel from "components/GoalYearModel";
import OTPModel from "components/OTPModel";
import SIPdateModel from "components/SIPdateModel";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import {
  CreateGoldFundingRules,
  CreatePOT,
  getPOTList,
} from "redux/actions/GoalAction";

const PrettoSlider = styled(Slider)({
  color: "#0C58B4",
  height: 8,
  marginBottom: 10,
  marginTop: 5,
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    height: 24,
    width: 24,
    backgroundColor: "#FFF3DB",
    "&:before": {
      boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    },
    "&:hover, &.Mui-focusVisible, &.Mui-active": {
      boxShadow: "none",
    },
  },
  "& .MuiSlider-valueLabel": {
    lineHeight: 1.2,
    fontSize: 12,
    background: "unset",
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: "50% 50% 50% 0",
    backgroundColor: "#0C58B4",
    transformOrigin: "bottom left",
    transform: "translate(50%, -100%) rotate(-45deg) scale(0)",
    "&:before": { display: "none" },
    "&.MuiSlider-valueLabelOpen": {
      transform: "translate(50%, -100%) rotate(-45deg) scale(1)",
    },
    "& > *": {
      transform: "rotate(45deg)",
    },
  },
});

interface ScrollableGridProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
}

const GoalHomeScreen: FC = () => {
  const [gift, setGift] = useState("Gold");
  const [selectedGoal, setSelectedGoal] = useState<any>();
  const [step, setStep] = useState<string>("");
  const [years, setYears] = useState<string>("");
  const [totalYears, setTotlaYears] = useState<number>(0);
  const [selectedInstrument, setSelectedInstrument] =
    useState<string>("Mutual Funds");
  const [riskType, setRisktype] = useState<string>("Low");
  const [goalType, setSelectedGoalType] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [goalAmmount, setGoalAmmount] = useState<any>();
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const containerRef = useRef<HTMLDivElement>(null);
  const [showLeftArrow, setShowLeftArrow] = useState(true);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const scrollRef = useRef<HTMLDivElement>(null);
  const [selectedGridRef, setSelectedGridRef] =
    useState<React.RefObject<HTMLDivElement> | null>(null);
  const [selectedDate, setSelectedDate] = useState("");
  const [sipDateList, setDateList] = useState(DateList);
  const [sipValue, setSipValue] = useState();
  const [investedValue, setInvestedValue] = useState();
  const [interestValue, setInterestValue] = useState();

  //yearError
  const [showYearError, setShowYearError] = useState(false);
  const [errorYearMessage, setErrorYearMessage] = useState("");
  const [progress, setProgress] = useState(10);
  const [openModal, setOpenModal] = useState(false);
  const [yearList, setYearList] = useState(Array);
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [goals, setGoals] = useState([]);
  const [oneDimensionalGoals, setOneDimensionalGoals] = useState([]);
  const [showaGoalNameError, setGoalNameError] = useState(false);
  const [errorGoalNameMessage, setGoalNameErrorMessage] = useState("");
  const [goalName, setGoalName] = useState<string>("");
  const handleNameChange = (event: any) => {
    setGoalNameError(false);
    setGoalName(event.target.value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const numericValue = event.target.value.replace(/\D/g, "");
    setGoalAmmount(numericValue);
    setShowError(false);
  };

  const [sliderReturnValue, setSliderReturnValue] = useState<any>(
    selectedInstrument === "Mutual Funds"
      ? 6
      : selectedInstrument === "Digital Gold"
      ? 6
      : 4
  );

  useEffect(() => {
    if (selectedGoal && selectedGridRef?.current) {
      selectedGridRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [selectedGridRef]);

  useEffect(() => {
    let rate = sliderReturnValue / 100;
    let R = rate / 12;
    let PMT = (goalAmmount * R) / (Math.pow(1 + R, totalYears * 12) - 1);
    let roundedSIP: any = PMT == Infinity ? 0 : Math.round(PMT);
    let investedAmount: any = Math.round(roundedSIP * totalYears * 12);
    let interestAmount: any = Math.round(goalAmmount - investedAmount);

    setSipValue(roundedSIP);
    setInvestedValue(investedAmount);
    setInterestValue(interestAmount);
  }, [sliderReturnValue, totalYears]);

  useEffect(() => {
    checkArrowsVisibility();
    window.addEventListener("resize", checkArrowsVisibility);
    return () => {
      window.removeEventListener("resize", checkArrowsVisibility);
    };
  }, []);

  useEffect(() => {
    checkToken();
  }, [gift]);

  useEffect(() => {
    setYearList(
      Array.from(
        { length: selectedGoal?.title == "Retirement" ? 40 : 30 },
        (_, i) => new Date().getFullYear() + i
      )
    );
  }, [selectedGoal]);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 0 : prevProgress + 10
      );
    }, 800);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const setRef = (item: any, ref: React.RefObject<HTMLDivElement>) => {
    if (selectedGoal === item) {
      setSelectedGridRef(ref);
    }
  };

  function valuetext(value: number) {
    setTotlaYears(value);
    return `${value}`;
  }
  const [sipdateModel, setSipDateModel] = useState(false);

  const handlesipOpenModal = () => {
    setSipDateModel(true);
  };
  const handlesipCloseModal = () => {
    setSipDateModel(false);
  };

  const dateOrdinal = (d: any) => {
    return (
      d +
      (31 == d || 21 == d || 1 == d
        ? "st"
        : 22 == d || 2 == d
        ? "nd"
        : 23 == d || 3 == d
        ? "rd"
        : "th")
    );
  };

  //verify OTP OneTime
  const handleSave = async (value: any) => {};

  const handleSaveSipDateModel = (value: any) => {
    setSelectedDate(value);
    handlesipCloseModal();
  };

  function valuetextReturn(value: number) {
    setSliderReturnValue(value);
    if (selectedInstrument === "Mutual Funds") {
      if (value < 7) {
        setRisktype("Low");
        return `${value}`;
      }
      if (value === 7 || value === 8) {
        setRisktype("Medium");
        return `${value}`;
      }
      if (value > 8) {
        setRisktype("High");
        return `${value}`;
      }
    }
    return `${value}`;
  }

  const handleOpenModal = () => {
    setOpenModal(true);
    setShowYearError(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSaveYear = (value: any, total: any) => {
    setTotlaYears(total);
    setYears(value);
    handleCloseModal();
  };

  const checkToken = async () => {
    let token = await load("token");
    if (token === undefined) {
      remove("userData");
      remove("token");
      toast.success("Session expired, please login again.");
      navigate("/login");
    } else {
      getGoals();
    }
  };

  const getGoals = () => {
    setLoading(true);
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);

    let token = load("token");
    dispatch(getPOTList(finalUser.id, token, finalUser?.mfia_id ?? "0"))
      .then(async (response: any) => {
        setLoading(false);
        if (response.statusCode === 400) {
          return;
        }
        if (response.statusCode === 204) {
          setGoals([]);
          return;
        }
        if (response.statusCode === 200) {
          const succesStatus = response.data?.filter(
            (i: any) =>
              i?.accountStatus == "ACTIVE" || i?.accountStatus == "CANCELLED"
          );
          setOneDimensionalGoals(succesStatus);
          setGoals(succesStatus);

          setLoading(false);
          return;
        }
      })
      .catch((error: any) => {
        setLoading(false);
      });
  };

  const onGoalTypeClick = (item: any) => {
    setShowYearError(false);
    setSelectedGoalType(item.title);
    setSelectedGoal(item);
    setStep("first");
    setYears("");
    setGoalAmmount("");
    // if (scrollRef.current) {
    //   const { scrollTop, scrollHeight } = scrollRef.current;
    //   scrollRef.current.scrollTop = scrollHeight - scrollTop;
    // }
  };

  const onNextClick = () => {
    const regex = /^-?\d+$/;
    if (selectedGoal.title === "Custom goal") {
      if (goalName === "") {
        setGoalNameError(true);
        setGoalNameErrorMessage("Please enter goal name.");
        return;
      }
    }
    if (!regex.test(goalAmmount)) {
      setShowError(true);
      setErrorMessage("Please enter a valid goal amount.");
      return;
    }
    if (goalAmmount === 0) {
      setShowError(true);
      setErrorMessage("Please enter the goal amount.");
      return;
    }
    if (goalAmmount < 5000) {
      setShowError(true);
      setErrorMessage("Goal ammount should be greater then 5000.");
      return;
    }
    if (years === "") {
      setShowYearError(true);
      setErrorYearMessage("Please select years.");
      return;
    } else {
      setStep("second");
    }
  };

  const onProceed = () => {
    if (Number(sipValue) < Number(100)) {
      toast.error(`Minimum sip amount is ₹${100}`);
      return;
    }
    if (
      selectedInstrument != "Mutual Funds" &&
      Number(sipValue) > Number(15000)
    ) {
      toast.error(`Maximum sip amount is ₹${15000}`);
      return;
    }

    const item: any = INSTRUMENT_TYPES?.find(
      (item) => item.name == selectedInstrument
    );

    item["isGoal"] = true;
    item["sipAmount"] = Number(sipValue);
    item["year"] = totalYears;
    item["return"] = sliderReturnValue;
    item["goalAmount"] = goalAmmount;
    item["goalName"] =
      selectedGoal?.title === "Custom goal" ? goalName : selectedGoal?.title;

    item.name == "Mutual Funds"
      ? navigate("/mutualfundcollections", {
          state: {
            item: {
              title:
                riskType == "Low"
                  ? "Liquid"
                  : riskType == "Medium"
                  ? "Hybrid"
                  : "Equity",
              icon: "liquidfunds",
              asset_sub_category: "",
              type:
                riskType == "Low"
                  ? "Fixed Income"
                  : riskType == "Medium"
                  ? "Hybrid"
                  : "Equity",
              isGoal: true,
              sipAmount: sipValue,
              year: totalYears,
              return: sliderReturnValue,
            },
            goalData: item,
            customer: null,
          },
        })
      : setStep("third");
  };

  const onGoldSilverSIPClick = async () => {
    if (!selectedDate) {
      toast.error(`Please select SIP date`);
      return;
    }

    await createGoal();
  };

  const createGoal = async () => {
    setLoading(true);
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let token = load("token");
    const req = {
      userId: finalUser.id,
      accountType: "fixed",
      accountName: `${
        selectedGoal?.title === "Custom goal" ? goalName : selectedGoal?.title
      } Goal`,
      accountBalance: Number(goalAmmount),
      accountStatus: "ACTIVE",
      productId: selectedInstrument == "Digital Gold" ? "gold" : "silver",
      productName: selectedInstrument == "Digital Gold" ? "Gold" : "Silver",
    };

    dispatch(CreatePOT(req, `${token}`))
      .then(async (response: any) => {
        if (response.status === 401 || response.status === 400) {
          setLoading(false);
          toast.error(response.message);
          return;
        }
        await createFundingRulesGoal(response?.data?.virtualAccountId);
      })
      .catch((error: any) => {
        toast.error("Goal Failed. Please try after sometimes");
        setLoading(false);
      });
  };

  const createFundingRulesGoal = async (virtualAccountId: string) => {
    let userDetail: any = load("userData");
    let finalUser = JSON.parse(userDetail);
    let token = load("token");
    setLoading(true);
    const format = "YYYY-MM-DD";
    var d = new Date();
    d.setDate(Number(sipValue));
    var year = d.getFullYear();
    var month = d.getMonth();
    var day = d.getDate();
    var endDate = moment(
      new Date(d.getFullYear() + totalYears, month, Number(sipValue))
    ).format(format);
    var nextDate;
    if (d.getMonth() == 11) {
      nextDate = moment(new Date(d.getFullYear() + 1, 0, 1)).format(format);
    } else {
      nextDate = moment(new Date(d.getFullYear(), d.getMonth() + 1, 1)).format(
        format
      );
    }
    const req = {
      userId: finalUser.id,
      fundingType: "FIX",
      autoFundingMethod: "subscription",
      fundingFrequency: "Monthly",
      roundingMethod: "",
      denomination: sipValue,
      startDate: moment(new Date()).format(format),
      endDate: endDate.toString(),
      nextDate: nextDate.toString(),
      virtualAccountId: virtualAccountId,
      subscriptionFrequencyUnit: "ONDEMAND",
      name: `${finalUser.firstname} ${finalUser.lastname}`,
      mobileNo: `91${finalUser.mobile}`,
      source: "web",
      callBackUrl: process.env.REACT_APP_GS_CALL_BACK_URL,
    };
    dispatch(CreateGoldFundingRules(req, `${token}`))
      .then(async (response: any) => {
        setLoading(false);

        if (response.statusCode === 400) {
          toast.error(response.body.message);
          return;
        }
        if (response?.statusCode === 200) {
          let newWindow: any = window.open("", "_self");

          await newWindow.document.write(`
          <html>
            <head>
              <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
              <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
              <title>Acru - Financial Wellness for All</title>
            </head>
            <body>
              <div id="waiting" style="display: block; font-family: sans-serif;">
                <br /><br />
                <center><h1>Please wait!</h1><h2> Do not refresh the page</h2></center>
              </div>
              <div id="done" style="display: none; font-family: sans-serif;">
                <br /><br />
                <center><h2>Payment has been cancelled.</h2><h4><nav><a href="/dashboard">Retry</a></nav></h4></center>
              </div>
              <div id="paytm-checkoutjs"></div>
              <script>
                function hidewaiting() {
                  setTimeout(() => {
                    document.getElementById("waiting").style.display = "none";
                  }, 10000);
                }
                
                function showdone() {
                  setTimeout(() => {
                    document.getElementById("done").style.display = "block";
                  }, 10000);
                }
                
                function onScriptLoad() {
                  var config = {
                    root: "",
                    flow: "DEFAULT",
                    data: {
                      "orderId": "${response?.data?.orderId}",
                        "token": "${response?.data?.txnToken}",
                        "tokenType": "TXN_TOKEN",
                        "amount": "${response?.data?.amount}"
                    },
                    handler: {
                      notifyMerchant: function(eventName, data) {
                        console.log("eventName => ", eventName);
                        console.log("data => ", data);
                        if (eventName === "APP_CLOSED") {
                          showdone();
                          hidewaiting();
                          console.log("ddd");
                        } else {
                          showdone();
                        }
                        console.log("eventName => ", eventName);
                        console.log("data:::-->>", data.message);
                      }
                    },
                  };
                  
                  if (window.Paytm && window.Paytm.CheckoutJS) {
                    window.Paytm.CheckoutJS.onLoad(function excecuteAfterCompleteLoad() {
                      window.Paytm.CheckoutJS.init(config)
                        .then(function onSuccess() {
                          window.Paytm.CheckoutJS.invoke();
                        })
                        .catch(function onError(error) {
                          console.log("error => ", error);
                        });
                    });
                  }
                  
                  window.history.pushState(null, null, window.location.href);
                  window.onpopstate = function() {
                    window.history.pushState(null, null, window.location.href);
                  };
                }
        
                var scriptTag = document.createElement("script");
                scriptTag.type = "application/javascript";
                scriptTag.crossOrigin = "anonymous";
                scriptTag.src = "${PAYMENT_URL_DEV}/merchantpgpui/checkoutjs/merchants/${MERCHANTS_ID}.js";
                scriptTag.onload = onScriptLoad;
        
                document.body.appendChild(scriptTag);
              </script>
            </body>
          </html>
        `);

          return;
        }
      })
      .catch((error: any) => {
        toast.error(error);
        setLoading(false);
      });
  };

  const checkArrowsVisibility = () => {
    if (containerRef.current) {
      const { scrollLeft, clientWidth, scrollWidth } = containerRef.current;
      const visibleItems = Math.floor(clientWidth / (clientWidth * 0.18));
      const totalItems = goals ? goals.length : 0;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(
        scrollWidth - scrollLeft > clientWidth && totalItems > visibleItems
      );
    }
  };

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: -200, // Adjust the scroll amount as needed
        behavior: "smooth",
      });
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({
        left: 200, // Adjust the scroll amount as needed
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <DashboardNavbar />
      <OTPModel
        open={openModal}
        handleClose={handleCloseModal}
        handleSave={handleSave}
      />
      <SIPdateModel
        open={sipdateModel}
        handleClose={handlesipCloseModal}
        handleSave={handleSaveSipDateModel}
        sipList={sipDateList || []} // add a default empty array if sipDateList is undefined
      />
      {loading ? (
        <Grid
          display="flex"
          flexDirection="column"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Grid>
      ) : (
        <Box
          sx={{
            background: "#F6F6F6",
            pl: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pr: {
              md: 10,
              xs: 2,
              sm: 2,
            },
            pb: 2,
            pt: 2,
          }}
        >
          <GoalTopBanner />
          <GoalYearModel
            open={openModal}
            handleClose={handleCloseModal}
            handleSave={handleSaveYear}
            data={yearList || []}
          />
          <Grid
            xs={12}
            md={8}
            sx={{
              mt: 2,
              mb: 2,
              borderRadius: 2,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                padding: {
                  md: 3,
                  xs: 3,
                  sm: 4,
                },
                pt: {
                  xs: 0,
                },
                width: "100%",
              }}
            >
              {goals.length === 0 ? null : (
                <>
                  <H3
                    sx={{
                      fontFamily: "'Poppins', sans-serif",
                      mb: goals.length === 0 ? 0 : 1,
                    }}
                  >
                    Current Goals ({oneDimensionalGoals?.length ?? "0"})
                  </H3>
                  <Box sx={{ position: "relative" }}>
                    <Box
                      sx={{
                        position: "relative",
                        overflowX: "auto",
                        width: "100%",
                        scrollbarWidth: "none",
                        "-ms-overflow-style": "none",
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                        display: "flex",
                      }}
                      ref={containerRef}
                      onScroll={checkArrowsVisibility}
                    >
                      {goals?.map((item: any, index: any) => (
                        <Grid
                          xs={12}
                          sm={6}
                          md={2}
                          key={index}
                          sx={{
                            background: "#ffff",

                            borderRadius: 2,
                            mb: 2,
                            justifyContent: "space-between",
                            display: "flex",
                            flexDirection: "column",
                            p: 1,
                            ml: index === 0 ? 0 : 2,
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            navigate("/goalDetails", {
                              state: {
                                item: item,
                              },
                            });
                          }}
                        >
                          <Box
                            sx={{
                              height: "15%",
                              borderRadius: 2,
                            }}
                          >
                            <H6
                              color="#141414"
                              fontWeight={"600"}
                              sx={{
                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              {item?.accountName}
                            </H6>
                          </Box>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              justifyContent: "center",
                              display: "flex",
                              paddingTop: -10,
                            }}
                          >
                            <ProgressBar
                              progress={item?.changeBy}
                              radius={40}
                              strokeWidth={5}
                              trackStrokeWidth={5}
                              strokeColor={
                                process.env.REACT_APP_BUTTON_ACTIVE_COLOR
                              }
                            />
                            <div
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                              }}
                            >
                              <H5
                                color={process.env.REACT_APP_PRIMARY_COLOR}
                                fontWeight={"650"}
                                sx={{
                                  color: process.env.REACT_APP_PRIMARY_COLOR,
                                  fontFamily: "'Poppins', sans-serif",
                                  width: "100%",
                                  textAlign: "center",
                                  flexDirection: "column",
                                  display: "flex",
                                }}
                              >
                                {item?.changeBy.toFixed(2)}%
                                <Tiny
                                  color="#000"
                                  fontWeight={"400"}
                                  sx={{
                                    fontFamily: "'Poppins', sans-serif",
                                    width: "100%",
                                    textAlign: "center",
                                    fontSize: 10,
                                  }}
                                >
                                  Completed
                                </Tiny>
                              </H5>
                            </div>
                          </div>

                          <Tiny
                            color="#141414"
                            fontWeight={"650"}
                            sx={{
                              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                              mt: -1.4,
                              width: "100%",
                              textAlign: "center",
                            }}
                          >
                            {" "}
                            ₹
                            <Tiny
                              color="#141414"
                              fontWeight={"600"}
                              sx={{
                                fontFamily: "'Poppins', sans-serif",
                                color:
                                  process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                              }}
                            >{`${item?.investedAmt}/ ${item?.accountBalance}`}</Tiny>
                          </Tiny>
                          {/* </Box> */}
                          <Box
                            sx={{
                              justifyContent: "space-between",
                              flexDirection: "row",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <Tiny
                              color="#595959"
                              fontWeight={"500"}
                              sx={{
                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              {`Installments: ${item?.remainingInstallment}`}
                            </Tiny>
                            <Box
                              sx={{
                                background: "#FFF9EC",
                                p: 0.5,
                                borderRadius: "50%",

                                alignItems: "center",
                                justifyContent: "center",
                                display: "flex",
                              }}
                            >
                              <Box
                                component="img"
                                sx={{
                                  height: 18,
                                  minwidth: 18,
                                }}
                                src={
                                  item?.accountName == "Trip Goal"
                                    ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/trip.svg"
                                    : item?.accountName == "Wedding Goal"
                                    ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/wedding.svg"
                                    : item?.accountName == "Education Goal"
                                    ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/education.svg"
                                    : item?.accountName == "Vehicle Goal"
                                    ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/vehicle.svg"
                                    : item?.accountName == "Home Goal"
                                    ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/home.svg"
                                    : item?.accountName == "Retirement Goal"
                                    ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/retirement.svg"
                                    : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/customGoal.svg"
                                }
                                alt="saas-dasboard-footer"
                              />
                            </Box>
                          </Box>
                        </Grid>
                      ))}
                    </Box>

                    {showLeftArrow && (
                      <Box
                        component="img"
                        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/arrowLeft.svg"
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: -15,
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#000",
                          zIndex: 1,
                        }}
                        onClick={handleScrollLeft}
                      />
                    )}

                    {showRightArrow && (
                      <Box
                        component="img"
                        src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/arrowRight.svg"
                        sx={{
                          position: "absolute",
                          top: "50%",
                          right: -15,
                          transform: "translateY(-50%)",
                          cursor: "pointer",
                          color: "#000",
                          zIndex: 1,
                        }}
                        onClick={handleScrollRight}
                      />
                    )}
                  </Box>
                </>
              )}
              <H4
                color="#141414"
                fontWeight={"600"}
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                }}
              >
                Pick a Goal
              </H4>
              <Grid
                container
                spacing={2}
                justifyContent="center"
                sx={{
                  mt: {
                    md: 2,
                    xs: 1,
                  },
                  mb: {
                    md: 8,
                    xs: 4,
                  },
                }}
              >
                {GOAL_TYPES.map((item: any, index: any) => (
                  <Grid xs={5} sm={6} md={1.5}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        p: 1,
                      }}
                    >
                      <Button
                        disableTouchRipple={true}
                        disableElevation={true}
                        disableRipple={true}
                        key={item.id}
                        ref={(ref: any) => setRef(item, ref)}
                        onClick={() => onGoalTypeClick(item)}
                        sx={{
                          alignItems: "center",
                          justifyItems: "center",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box
                          sx={{
                            alignItems: "center",
                            justifyContent: "center",
                            display: "flex",
                            flexDirection: "row",
                            objectFit: "contain",
                          }}
                        >
                          <Box
                            sx={{
                              background: "#fff",
                              p: 1,
                              borderRadius: "50%",
                              mb: {
                                md: 2,
                                xs: 1,
                                sm: 1,
                              },
                              height: 40,
                              width: 40,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              component="img"
                              sx={{
                                height: 30,
                                minwidth: 30,
                                mt: 0.5,
                              }}
                              src={item.icon}
                              alt="saas-dasboard-footer"
                            />
                          </Box>
                        </Box>
                        <H6
                          color="#595959"
                          fontWeight={"400"}
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                          }}
                        >
                          {item.title}
                        </H6>
                      </Button>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
            {step === "first" && (
              <Grid
                container
                ref={selectedGridRef}
                sx={{
                  background: "#fff",
                  width: {
                    md: "50%",
                    xs: "100%",
                  },
                  borderRadius: 2,
                  mb: 2,
                  display: "flex",
                  p: 2,
                  alignItems: "center",
                  justifyContent: "center",
                  pt: 5,
                  pb: 5,
                  pl: 1.5,
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    display: "flex",
                    height: 20,
                  }}
                >
                  <Box
                    sx={{
                      background: "#FEF7E3",
                      p: 1.2,
                      borderRadius: "50%",
                      mb: {
                        md: 2,
                        xs: 1,
                        sm: 1,
                      },
                      height: 60,
                      width: 60,
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: 2,
                      display: "flex",
                      position: "relative",
                      alignSelf: "center",
                      top: -40,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: 40,
                        minwidth: 40,
                      }}
                      src={selectedGoal?.icon}
                      alt="saas-dasboard-footer"
                    />
                  </Box>
                </Box>
                <H4
                  color="#141414"
                  fontWeight={"600"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    mt: 1,
                    width: {
                      md: "90%",
                      xs: "100%",
                    },
                    textAlign: "left",
                  }}
                >
                  {selectedGoal?.heading}
                </H4>
                {selectedGoal?.title === "Custom goal" && (
                  <Box
                    sx={{
                      flexDirection: "column",
                      width: {
                        xs: "100%",
                        sm: "100%",
                        md: "90%",
                      },
                      mt: 2,
                    }}
                  >
                    <Small sx={textHeading} fontWeight={"300"}>
                      What do you want to save for?
                    </Small>
                    <TextField
                      name="recieverName"
                      sx={textInputStyles}
                      InputProps={{
                        style: {
                          height: "40px", // change this value to set the desired height
                        },
                      }}
                      onChange={handleNameChange}
                    />
                    {showaGoalNameError && (
                      <Small fontSize={12} sx={errorStyle}>
                        {errorGoalNameMessage}
                      </Small>
                    )}
                  </Box>
                )}
                <Box
                  sx={{
                    flexDirection: "column",
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "90%",
                    },
                    mt: 2,
                  }}
                >
                  <Small sx={textHeading} fontWeight={"300"}>
                    {selectedGoal?.amountHeading}
                  </Small>
                  <TextField
                    name="goalAmmount"
                    sx={textInputStyles}
                    inputProps={{
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                    }}
                    value={goalAmmount}
                    InputProps={{
                      style: {
                        height: "40px",
                      },
                    }}
                    onChange={handleChange}
                  />
                  {showError && (
                    <Small fontSize={12} sx={errorStyle}>
                      {errorMessage}
                    </Small>
                  )}
                </Box>
                <Box
                  sx={{
                    flexDirection: "column",
                    width: {
                      xs: "100%",
                      sm: "100%",
                      md: "90%",
                    },
                    mt: 2,
                  }}
                >
                  <Small sx={textHeading} fontWeight={"300"}>
                    {selectedGoal?.yearHeading}
                  </Small>
                  <Box
                    onClick={handleOpenModal}
                    sx={{
                      background: "#fff",
                      p: 1.2,
                      borderRadius: 1,
                      mb: {
                        md: 0.5,
                        xs: 1,
                        sm: 1,
                      },
                      height: 20,
                      mt: 0.8,
                      display: "flex",
                      alignSelf: "center",
                      width: {
                        xs: "94%",
                        sm: "94%",
                        md: "96.5%",
                      },
                      border: "1px solid #bbb",
                    }}
                  >
                    {years}
                  </Box>
                  {showYearError && (
                    <Small fontSize={12} sx={errorStyle}>
                      {errorYearMessage}
                    </Small>
                  )}
                </Box>
                <Button
                  onClick={onNextClick}
                  disableElevation
                  disableRipple
                  size="medium"
                  sx={{
                    background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                    color: "#fff",
                    width: {
                      xs: "100%",
                      sm: "94%",
                      md: "50%",
                    },
                    mt: 4,
                    borderRadius: 2,
                  }}
                >
                  Next
                </Button>
              </Grid>
            )}
            {step === "second" && (
              <Grid
                container
                sx={{
                  background: "#fff",
                  width: "100%",
                  borderRadius: 2,
                  mb: 2,
                  p: {
                    md: 2,
                    xs: 0,
                  },
                  justifyContent: {
                    xs: "center",
                  },
                  display: "flex",
                }}
              >
                <Box
                  sx={{
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",

                    display: "flex",
                  }}
                >
                  <Box
                    sx={{
                      background: "#FEF7E3",
                      p: 1,
                      borderRadius: "50%",
                      mb: {
                        md: 2,
                        xs: 1,
                        sm: 1,
                      },
                      height: 60,
                      width: 60,
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: 2,
                      display: "flex",
                      position: "relative",
                      alignSelf: "center",
                      top: -50,
                    }}
                  >
                    <Box
                      component="img"
                      sx={{
                        height: 45,
                        minwidth: 45,
                      }}
                      src={selectedGoal?.icon}
                      alt="saas-dasboard-footer"
                    />
                  </Box>
                </Box>
                <H4
                  color="#141414"
                  fontWeight={"600"}
                  sx={{
                    fontFamily: "'Poppins', sans-serif",
                    width: "100%",
                    textAlign: "left",
                    mt: {
                      md: -10,
                      xs: -5,
                    },
                    ml: {
                      md: 2,
                      xs: 2,
                    },
                  }}
                >
                  Plan your dream {selectedGoal?.title.toLowerCase()}
                </H4>
                <Grid
                  container
                  sx={{
                    width: "100%",
                    borderRadius: 2,

                    justifyContent: "space-between",
                    display: "flex",
                    p: 2,
                    flexDirection: "row",
                    mt: {
                      md: -8,
                      xs: -4,
                    },
                  }}
                >
                  <Grid
                    xs={12}
                    md={6}
                    sx={{
                      background: "#fff",
                      borderRadius: 2,
                      boxShadow: "0px 4px 29px rgba(0, 0, 0, 0.1)",
                      p: 2,
                    }}
                  >
                    <H4
                      color="#141414"
                      fontWeight={"600"}
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        mb: 1,
                      }}
                    >
                      Calculate your returns
                    </H4>
                    <Small sx={subheadingMain}>
                      Years to {selectedGoal?.title.toLowerCase()}
                    </Small>

                    <PrettoSlider
                      valueLabelDisplay="auto"
                      aria-label="years slider"
                      defaultValue={totalYears}
                      max={yearList.length}
                      min={1}
                      getAriaValueText={valuetext}
                    />
                    <H4
                      fontSize={12}
                      fontFamily="'Poppins', sans-serif"
                      sx={{ textAlign: "center", marginTop: -2 }}
                    >
                      {totalYears} years
                    </H4>
                    <Small sx={subheadingMain}>
                      Select Investment Instrument
                    </Small>
                    <Box sx={instrumentContainer}>
                      {INSTRUMENT_TYPES.map((item: any, index: any) => (
                        <Box
                          sx={{
                            mt: 1,
                            display: "flex",
                            // ml: index === 0 ? 0 : 1.5,
                          }}
                        >
                          <Button
                            disableTouchRipple={true}
                            disableElevation={true}
                            disableRipple={true}
                            onClick={() => {
                              setSelectedInstrument(item.name);
                            }}
                            sx={{
                              alignItems: "center",
                              justifyItems: "center",
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <Box
                              sx={{
                                background:
                                  selectedInstrument === item.name
                                    ? "#FFF3DB"
                                    : "#fff",
                                p: 1,
                                borderRadius: 2,
                                mb: {
                                  md: 2,
                                  xs: 1,
                                  sm: 1,
                                },
                                height: 30,
                                width: 30,
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0px 4px 29px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <Box
                                component="img"
                                sx={{
                                  height: 25,
                                  minwidth: 25,
                                  mt: 0.5,
                                }}
                                src={item.image}
                                alt="saas-dasboard-footer"
                              />
                            </Box>
                            <Tiny
                              color="#595959"
                              fontWeight={"400"}
                              sx={{
                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              {item.name}
                            </Tiny>
                          </Button>
                        </Box>
                      ))}
                    </Box>
                    <Small sx={subheadingMain}>
                      Expected Returns per annum
                    </Small>
                    <PrettoSlider
                      valueLabelDisplay="auto"
                      aria-label="per annum returns"
                      defaultValue={sliderReturnValue}
                      max={
                        selectedInstrument === "Mutual Funds"
                          ? 15
                          : selectedInstrument === "Digital Gold"
                          ? 12
                          : 5
                      }
                      getAriaValueText={valuetextReturn}
                      min={1}
                    />
                    <H4
                      fontSize={12}
                      fontFamily="'Poppins', sans-serif"
                      sx={{ textAlign: "center", marginTop: -2 }}
                    >
                      {sliderReturnValue}%/per annum
                    </H4>
                    {/* Low mEdium high */}
                    <Grid
                      container
                      sx={{
                        justifyContent: "space-between",
                        mb: 2,
                        mt: 1,
                      }}
                    >
                      {selectedInstrument === "Mutual Funds" && (
                        <>
                          <Box
                            sx={{
                              backgroundColor:
                                riskType === "Low"
                                  ? process.env.REACT_APP_PRIMARY_COLOR
                                  : "#FEF7E3",
                              padding: "8px",
                              borderRadius: "8px",
                              textAlign: "center",
                              cursor: "pointer",
                              width: {
                                md: 80,
                                xs: 50,
                                sm: 60,
                              },
                            }}
                            onClick={() => {
                              setRisktype("Low");
                              setSliderReturnValue(6);
                            }}
                          >
                            <Small
                              fontWeight={550}
                              sx={{
                                color: riskType === "Low" ? "#fff" : "#000",
                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              Low
                            </Small>
                          </Box>
                          <Box
                            sx={{
                              backgroundColor:
                                riskType === "Medium"
                                  ? process.env.REACT_APP_PRIMARY_COLOR
                                  : "#FEF7E3",
                              padding: "8px",
                              borderRadius: "8px",
                              textAlign: "center",
                              cursor: "pointer",
                              width: {
                                md: 80,
                                xs: 60,
                                sm: 60,
                              },
                            }}
                            onClick={() => {
                              setRisktype("Medium");
                              setSliderReturnValue(7);
                            }}
                          >
                            <Small
                              fontWeight={550}
                              sx={{
                                color: riskType === "Medium" ? "#fff" : "#000",
                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              Medium
                            </Small>
                          </Box>
                          <Box
                            sx={{
                              backgroundColor:
                                riskType === "High"
                                  ? process.env.REACT_APP_PRIMARY_COLOR
                                  : "#FEF7E3",
                              padding: "8px",
                              borderRadius: "8px",
                              textAlign: "center",
                              cursor: "pointer",
                              width: {
                                md: 80,
                                xs: 50,
                                sm: 60,
                              },
                            }}
                            onClick={() => {
                              setRisktype("High");
                              setSliderReturnValue(13);
                            }}
                          >
                            <Small
                              fontWeight={550}
                              sx={{
                                color: riskType === "High" ? "#fff" : "#000",
                                fontFamily: "'Poppins', sans-serif",
                              }}
                            >
                              High
                            </Small>
                          </Box>
                        </>
                      )}
                    </Grid>
                    <Tiny
                      color="#595959"
                      fontWeight={"400"}
                      sx={{
                        fontFamily: "'Poppins', sans-serif",
                        mt: 2,
                        textAlign: "center",
                        width: "100%",
                      }}
                    >
                      {selectedInstrument == "Mutual Funds"
                        ? riskType == "Low"
                          ? `Grow your wealth with peace of mind using ${riskType?.toLowerCase()}-risk mutual funds(1-6% returns)`
                          : riskType == "Medium"
                          ? `Balance your investment portfolio with medium-risk mutual funds(7-10% returns)`
                          : `Don't miss out on the potential growth of high-risk mutual funds(11-15% returns)`
                        : selectedInstrument == "Digital Gold"
                        ? GOLD_DISCLAIMER
                        : SILVER_DISCLAIMER}
                    </Tiny>
                  </Grid>
                  <Grid
                    xs={12}
                    md={6}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "center",
                      paddingX: {
                        md: 3,
                        xs: 0,
                        sm: 0,
                      },
                    }}
                  >
                    <Box
                      sx={{
                        border: "6px solid #124EC2",
                        height: 100,
                        width: 100,
                        borderRadius: "50%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        mb: 2,
                        mt: {
                          xs: 3,
                          md: 0,
                        },
                      }}
                    >
                      <Tiny
                        color="#595959"
                        fontWeight={"400"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          textAlign: "center",
                        }}
                      >
                        Goal Amount
                      </Tiny>
                      <H4
                        color="#002876"
                        fontWeight={"700"}
                        sx={{
                          display: "flex",
                        }}
                      >
                        ₹{" "}
                        <H4
                          color="#002876"
                          fontWeight={"600"}
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                            mt: 0.1,
                          }}
                        >
                          {goalAmmount}
                        </H4>
                      </H4>
                    </Box>
                    <Box
                      sx={{
                        background: "#fff",
                        boxShadow: "0px 4px 29px rgba(0, 0, 0, 0.1)",
                        width: "100%",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        borderRadius: 2,
                        paddingY: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: "50%",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <H4
                          color="#141414"
                          fontWeight={"700"}
                          sx={{
                            display: "flex",
                          }}
                        >
                          ₹{" "}
                          <H4
                            color="#141414"
                            fontWeight={"600"}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              textAlign: "center",
                              mt: 0.1,
                            }}
                          >
                            {investedValue}
                          </H4>
                        </H4>
                        <Tiny
                          color="#595959"
                          fontWeight={"400"}
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                          }}
                        >
                          Invested Amount
                        </Tiny>
                      </Box>
                      <Box
                        sx={{
                          width: "50%",
                          flexDirection: "column",
                          justifyContent: "center",
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        <H4
                          color="#141414"
                          fontWeight={"700"}
                          sx={{
                            display: "flex",
                          }}
                        >
                          ₹{" "}
                          <H4
                            color="#141414"
                            fontWeight={"600"}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              textAlign: "center",
                              mt: 0.1,
                            }}
                          >
                            {interestValue}
                          </H4>
                        </H4>
                        <Tiny
                          color="#595959"
                          fontWeight={"400"}
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                          }}
                        >
                          Interest{" "}
                        </Tiny>
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        background: "#FEF7E3",

                        width: "90%",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        borderRadius: 2,
                        paddingY: 2,
                        mt: 2,
                      }}
                    >
                      <Tiny
                        color="#595959"
                        fontWeight={"400"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          textAlign: "center",
                        }}
                      >
                        Your installment amount will be
                      </Tiny>

                      <H4
                        color="#141414"
                        fontWeight={"700"}
                        sx={{
                          display: "flex",
                          mt: 0.5,
                        }}
                      >
                        ₹{" "}
                        <H4
                          color="#141414"
                          fontWeight={"600"}
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                            mt: 0.1,
                          }}
                        >
                          {sipValue}
                        </H4>
                        <H4
                          color="#141414"
                          fontWeight={"600"}
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            textAlign: "center",
                          }}
                        >
                          /Month
                        </H4>{" "}
                      </H4>
                    </Box>
                    <Button
                      onClick={onProceed}
                      disableElevation
                      disableRipple
                      size="medium"
                      sx={{
                        background: process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                        color: "#fff",
                        width: {
                          md: "50%",
                          xs: "90%",
                        },
                        mt: {
                          md: 1,
                          xs: 2,
                        },
                        textTransform: "none",
                      }}
                    >
                      Proceed
                    </Button>
                  </Grid>
                  <Box
                    sx={{
                      mt: 4,
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Tiny
                      color="#595959"
                      fontWeight={"400"}
                      sx={{
                        fontFamily: "'Poppins', sans-serif",

                        textAlign: "center",
                        width: {
                          md: "60%",
                          xs: "100%",
                        },
                        color: "#f00",
                      }}
                    >
                      {`Disclaimer*: `}{" "}
                      <Tiny
                        color="#595959"
                        fontWeight={"400"}
                        sx={{
                          fontFamily: "'Poppins', sans-serif",
                          mt: 2,
                        }}
                      >
                        {MUTUAL_DISCLAIMER}
                      </Tiny>
                    </Tiny>
                  </Box>
                </Grid>
              </Grid>
            )}
            {step === "third" && (
              <Grid
                container
                sx={{
                  mt: 0,
                }}
              >
                <Grid
                  xs={12}
                  md={12}
                  sx={{
                    padding: {
                      md: 3,
                      xs: 0,
                      sm: 0,
                    },
                    pr: 2,
                    mt: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Grid
                    sx={{
                      background: "#fff",
                      borderRadius: 5,
                      width: {
                        md: "50%",
                        xs: "100%",
                      },
                    }}
                  >
                    <Box sx={sxStyleBox1}>
                      <Box
                        sx={{
                          background:
                            "linear-gradient(180deg, #FEF7E3 0%, #FFFFFF 100%), #EDFFFF",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          p: 2,
                        }}
                      >
                        <Box
                          sx={{
                            background: "#fff",
                            p: 1,
                            borderRadius: "50%",
                            height: 80,
                            width: 80,
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0px 4px 29px rgba(0, 0, 0, 0.1)",
                            display: "flex",
                          }}
                        >
                          <Box
                            component="img"
                            sx={{
                              height: 60,
                              minwidth: 60,
                            }}
                            src={
                              selectedInstrument === "Digital Gold"
                                ? "https://acru-asset.s3.us-east-1.amazonaws.com/assets/gold.svg"
                                : "https://acru-asset.s3.us-east-1.amazonaws.com/assets/silver.svg"
                            }
                            alt="saas-dasboard-footer"
                          />
                        </Box>

                        <H5
                          fontWeight={"600"}
                          sx={{
                            fontFamily: "'Poppins', sans-serif",
                            color: "#000000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            mt: 1,
                          }}
                        >
                          {selectedInstrument} Investment
                        </H5>
                        <Small sx={subheading}>
                          <Small sx={subheadingMain}>SIP Amount:</Small> ₹
                          <Small sx={subheadingMain}>{sipValue}</Small>
                        </Small>
                      </Box>
                      <Divider />
                      <Grid
                        justifyContent="space-between"
                        sx={{ p: 1, display: "flex" }}
                      >
                        <Grid
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            pl: 1,
                          }}
                        >
                          <H5
                            fontWeight={"400"}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              color: "#000000",
                              display: "flex",
                            }}
                          >
                            <CalendarMonthIcon
                              style={{
                                color: process.env.REACT_APP_PRIMARY_COLOR,
                                fontSize: "1.3rem",
                                marginRight: 5,
                              }}
                            />
                            Date of SIP
                          </H5>
                        </Grid>
                        <Grid
                          onClick={() => handlesipOpenModal()}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                            pr: {
                              md: 2,
                              xs: 0,
                            },
                          }}
                        >
                          <H5
                            fontWeight={"400"}
                            sx={{
                              fontFamily: "'Poppins', sans-serif",
                              color: "#000000",
                              flexDirection: "row",
                            }}
                          >
                            {`${
                              selectedDate == ""
                                ? "Please select installment date"
                                : `${dateOrdinal(selectedDate)} of every month`
                            } `}
                          </H5>
                          <Box
                            component="img"
                            src="https://acru-asset.s3.us-east-1.amazonaws.com/assets/dropDown.svg"
                            sx={sxStyleDropDown}
                          />
                        </Grid>
                      </Grid>
                      <Divider />

                      <Grid textAlign="center">
                        <Button
                          onClick={() => onGoldSilverSIPClick()}
                          disableElevation
                          disableRipple
                          size="medium"
                          sx={{
                            background:
                              process.env.REACT_APP_BUTTON_GRADIENT_COLOR,
                            color: "#fff",
                            width: {
                              md: "50%",
                              xs: "90%",
                            },
                            mb: 1,
                            mt: 2,
                            textTransform: "none",
                          }}
                        >
                          Start SIP
                        </Button>
                      </Grid>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Box>
      )}
    </>
  );
};

export default GoalHomeScreen;

const sxStyleBox1 = {
  width: "100%",
  borderRadius: 5,
  pb: 1,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
};
const subheadingMain = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: "500",
};
const subheading = {
  fontWeight: "500",
};
const sliderStyle = {
  color: "#0C58B4",
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-thumb": {
    width: 24,
    height: 24,
    backgroundColor: "#FFF3DB",
    "&:before": {
      boxShadow: "0 4px 8px rgba(0,0,0,0.4)",
    },
    "&:hover, &.Mui-focusVisible, &.Mui-active": {
      boxShadow: "none",
    },
  },
  mt: 0.8,
  mr: 4,
};
const sxStyleDropDown = {
  height: {
    xs: 6,
    sm: 6,
    md: 6,
  },
  minwidth: {
    xs: 6,
    sm: 6,
    md: 6,
  },
};
const instrumentContainer = {
  display: "flex",
  mb: 2,
  justifyContent: {
    md: "flex-start",
    xs: "space-between",
  },
};

const textHeading = {
  fontFamily: "'Poppins', sans-serif",
  fontWeight: "500",
};
const textInputStyles = {
  width: {
    xs: "100%",
    sm: "100%",
    md: "100%",
  },
  marginTop: {
    xs: 0.5,
    sm: 2,
    md: 0.5,
  },
  padding: 0.2,
};
const errorStyle = {
  color: "#f00",
  textAlign: "left",
  width: "100%",
  fontFamily: "'Poppins', sans-serif",
  mt: 1,
};
